import _taggedTemplateLiteral from "/Users/jeason/Documents/Todos/oxygen/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
import _classCallCheck from "/Users/jeason/Documents/Todos/oxygen/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/Users/jeason/Documents/Todos/oxygen/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/jeason/Documents/Todos/oxygen/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _get from "/Users/jeason/Documents/Todos/oxygen/node_modules/@babel/runtime/helpers/esm/get";
import _createClass from "/Users/jeason/Documents/Todos/oxygen/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/jeason/Documents/Todos/oxygen/node_modules/@babel/runtime/helpers/esm/inherits";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    <style>\n      :host {\n        display: inline-block;\n        position: relative;\n        padding: 5px;\n      }\n    \n      :host(.pending) {\n        opacity: 0;\n      }\n    \n      .overlay {\n        position: absolute;\n        top: 0;\n        left: 0;\n        right: 0;\n        bottom: 0;\n        pointer-events: none;\n      }\n    \n      svg {\n        display: block;\n      }\n    \n      path {\n        stroke: currentColor;\n        stroke-width: 0.7;\n        fill: transparent;\n      }\n    </style>\n    <div>\n      <slot on-slotchange=\"", "\"></slot>\n    </div>\n    <div class=\"overlay\">\n      <svg id=\"svg\"></svg>\n    </div>\n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { LitElement, html } from '@polymer/lit-element/lit-element.js';
import { wired } from 'wired-lib/wired-lib.js';
export var WiredCard =
/*#__PURE__*/
function (_LitElement) {
  _inherits(WiredCard, _LitElement);

  _createClass(WiredCard, null, [{
    key: "properties",
    get: function get() {
      return {
        elevation: Number
      };
    }
  }]);

  function WiredCard() {
    var _this;

    _classCallCheck(this, WiredCard);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WiredCard).call(this));
    _this.elevation = 1;
    return _this;
  }

  _createClass(WiredCard, [{
    key: "_createRoot",
    value: function _createRoot() {
      var root = this.attachShadow({
        mode: 'open'
      });
      this.classList.add('pending');
      return root;
    }
  }, {
    key: "_render",
    value: function _render() {
      var _this2 = this;

      return html(_templateObject(), function () {
        return _this2.requestRender();
      });
    }
  }, {
    key: "_clearNode",
    value: function _clearNode(node) {
      while (node.hasChildNodes()) {
        node.removeChild(node.lastChild);
      }
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this3 = this;

      _get(_getPrototypeOf(WiredCard.prototype), "connectedCallback", this).call(this);

      setTimeout(function () {
        return _this3._didRender();
      });
    }
  }, {
    key: "_didRender",
    value: function _didRender() {
      var svg = this.shadowRoot.getElementById('svg');

      this._clearNode(svg);

      var s = this.getBoundingClientRect();
      var elev = Math.min(Math.max(1, this.elevation), 5);
      var w = s.width + (elev - 1) * 2;
      var h = s.height + (elev - 1) * 2;
      svg.setAttribute("width", w);
      svg.setAttribute("height", h);
      wired.rectangle(svg, 0, 0, s.width, s.height);

      for (var i = 1; i < elev; i++) {
        wired.line(svg, i * 2, s.height + i * 2, s.width + i * 2, s.height + i * 2).style.opacity = (85 - i * 10) / 100;
        wired.line(svg, s.width + i * 2, s.height + i * 2, s.width + i * 2, i * 2).style.opacity = (85 - i * 10) / 100;
        wired.line(svg, i * 2, s.height + i * 2, s.width + i * 2, s.height + i * 2).style.opacity = (85 - i * 10) / 100;
        wired.line(svg, s.width + i * 2, s.height + i * 2, s.width + i * 2, i * 2).style.opacity = (85 - i * 10) / 100;
      }

      this.classList.remove('pending');
    }
  }]);

  return WiredCard;
}(LitElement);
customElements.define('wired-card', WiredCard);